import React, { useState, useRef, useEffect } from "react";
import { getS3URL } from "../../../../_helpers";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";

const ForumReplies = ({
  commnetsdata,
  index,
  userId,
  previousPostIndex,
  setDeleteResponse,
  setLoad,
  userQueryActionHandler,
  nestedRepliesCollection,
  fetchUserForumPosts,
  getByIdRepliesCollectionHandlers,
  forumId,
  setForumId
}) => {
  const wrapperRef = useRef(null);
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const [userForumsInnermostRespondArray, setUserForumsInnermostRespondArray] =
    useState();
  const [dropList, setDropList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();

  const [isForumInnermostRepliesShow, setIsForumInnermostRepliesShow] =
    useState(false);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const postDeleteHandler = async (currentIndex, userCurrentActionStatus) => {
    try {
      const res = await axiosInstance.delete(`${REACT_APP_LOGIN_API_BASEURL}/forum/${currentIndex}`);
      setDeleteResponse(res.data.message);

      if (userCurrentActionStatus) {
        setUserForumsInnermostRespondArray((current) =>
          current.filter((items) => items.id !== currentIndex)
        );
      }

      fetchUserForumPosts();
      getByIdRepliesCollectionHandlers(previousPostIndex);
      setLoad(true);
    } catch (error) {
      console.error("Error deleting forum post:", error);
    }
  };

  const getByIdRepliesCollectionHandler = async (currentIdIndex) => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/forum/${currentIdIndex}`);
      setUserForumsInnermostRespondArray(res?.data?.data?.replies);
      setIsForumInnermostRepliesShow(true);
    } catch (error) {
      console.error("Error fetching forum replies:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (
      nestedRepliesCollection !== null &&
      commnetsdata.id === nestedRepliesCollection
    ) {
      getByIdRepliesCollectionHandler(nestedRepliesCollection);
    }
  }, [nestedRepliesCollection]);

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };

  return (

    <div className="userComments-Section bg-white rounded-xl shadow-md p-6 mb-6" key={index}>
      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
              {commnetsdata?.profileImage ? (
                <img
                  alt="profile"
                  src={commnetsdata?.profileImage}
                  className="object-cover w-full h-full"
                />
              ) : (
                <span className="text-gray-500 text-xl font-bold">
                  {commnetsdata?.firstName?.[0]}
                </span>
              )}
            </div>
            <div>
              <div className="font-semibold text-gray-800">
                {commnetsdata?.firstName} {commnetsdata?.lastName}
              </div>
              <div className="text-xs text-gray-400">{commnetsdata.title}</div>
            </div>
          </div>
          <div className="text-xs text-gray-400">
            {moment(commnetsdata?.time).format("MM/DD/YYYY")}
          </div>
          {commnetsdata.userId === userId && (
            <div className="relative ml-2">
              <button
                className="p-1 rounded-full hover:bg-gray-100"
                onClick={() => setDropList(!dropList)}
              >
                <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <circle cx="4" cy="10" r="2" />
                  <circle cx="10" cy="10" r="2" />
                  <circle cx="16" cy="10" r="2" />
                </svg>
              </button>
              {dropList && (
                <div className="!absolute right-0 mt-2 w-28 bg-white border border-gray-200 rounded-lg shadow-lg z-10" ref={wrapperRef}>
                  <ul>
                    {!commnetsdata.replies > 0 && (
                      <li
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
                        onClick={() =>
                          userQueryActionHandler(
                            true,
                            commnetsdata,
                            "levelOne",
                            previousPostIndex
                          )
                        }
                      >
                        Edit
                      </li>
                    )}
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-red-500"
                      onClick={() => postDeleteHandler(commnetsdata.id)}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="mt-2">
          <p className="text-gray-700 mb-3">{commnetsdata.description}</p>
          {/* <div className="flex flex-wrap gap-3 mb-2">
            {Array.isArray(commnetsdata?.files) &&
              commnetsdata.files.map((file, key) => (
                <div key={key} className="w-full rounded-lg border border-gray-200 p-2 bg-gray-50">
                  {file?.fileName?.includes(".pdf") ? (
                    <span
                      className="text-blue-600 underline cursor-pointer"
                      onClick={() => showHandler(getS3URL(file.objectKey))}
                    >
                      {file.fileName}
                    </span>
                  ) : file?.fileName?.includes(".mp4") ? (
                    <video
                      src={getS3URL(file.objectKey)}
                      alt="forum-video"
                      controls
                      className="w-full h-[400px] rounded"
                    />
                  ) : (
                    <img
                      src={getS3URL(file.objectKey)}
                      alt="forum-image"
                      className="w-full h-[400px] object-cover rounded"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = require("../../../../assets/images/bgimages.webp");
                      }}
                    />
                  )}
                </div>
              ))}
          </div> */}
          <div className="flex flex-wrap gap-3 mb-2">
            {commnetsdata.medialink ? (
              <div className="w-full rounded-lg border border-gray-200 p-2 bg-gray-50">
                {commnetsdata.medialink.match(/\.(mp4|mov)$/i) ? (
                  <video
                    src={commnetsdata.medialink}
                    controls
                    className="w-full h-[400px] rounded"
                  />
                ) : commnetsdata.medialink.match(/\.(pdf|xlsx|docx|ppt|pptx)$/i) ? (
                  <a
                    href={commnetsdata.medialink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline cursor-pointer"
                  >
                    {commnetsdata.medialink.split("/").pop()}
                  </a>
                ) : (
                  <img
                    src={commnetsdata.medialink}
                    alt="forum-media"
                    className="w-full h-[400px] object-cover rounded"
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = require("../../../../assets/images/bgimages.webp");
                    }}
                  />
                )}
              </div>
            ) : null}
          </div>
          {commnetsdata.medialink && (
            <p className="text-xs text-blue-500 underline break-all mb-2">
              <a href={commnetsdata.medialink} target="_blank" rel="noreferrer">
                {commnetsdata?.medialink}
              </a>
            </p>
          )}
          <div className="flex items-center gap-4 mt-2">
            {commnetsdata.replies > 0 && (
              <button
                className="text-blue-600 text-sm font-medium hover:underline"
                onClick={() =>
                  userForumsInnermostRespondArray?.length > 0
                    ? setIsForumInnermostRepliesShow(!isForumInnermostRepliesShow)
                    : getByIdRepliesCollectionHandler(commnetsdata.id)
                }
              >
                {commnetsdata.replies} Replies
              </button>
            )}
            <button
              className="bg-blue-50 text-blue-700 px-4 py-1 rounded hover:bg-blue-100 text-sm font-medium"
              onClick={() =>
                userQueryActionHandler(
                  false,
                  commnetsdata,
                  "levelOne",
                  previousPostIndex
                )
              }
            >
              Reply
            </button>
          </div>
        </div>
      </div>
      {isForumInnermostRepliesShow && (
        <div className="sub-commentbox mt-4 border-l-4 border-blue-100 pl-4">
          {userForumsInnermostRespondArray &&
            userForumsInnermostRespondArray.length > 0 &&
            userForumsInnermostRespondArray.map(
              (commnetsdataReplies, secindex) => (
                <InnerReplies
                  commnetsdata={commnetsdataReplies}
                  previousPostIndex={commnetsdata.id}
                  userQueryActionHandler={userQueryActionHandler}
                  secindex={secindex}
                  userId={userId}
                  postDeleteHandler={postDeleteHandler}
                />
              )
            )}
        </div>
      )}
      {isLoading && <Loading />}
      {printCertificate && (
        <OverlayContainer>
          <ChapterDocument
            type={"pdf"}
            url={cerftificateUrl}
            closeHandler={showHandler}
            show={printCertificate}
          />
        </OverlayContainer>
      )}
    </div>
  );
};
export default ForumReplies;



export const InnerReplies = ({
  commnetsdata,
  secindex,
  previousPostIndex,
  postDeleteHandler,
  userQueryActionHandler,
  userId,
}) => {
  const wrapperRef = useRef(null);
  const [dropList, setDropList] = useState(false);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div
      className="bg-blue-50 border-l-4 border-blue-400 rounded-lg shadow-sm p-4 mb-4 ml-6"
      key={secindex}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
            {commnetsdata?.profileImage ? (
              <img
                alt="profile"
                src={commnetsdata?.profileImage}
                className="object-cover w-full h-full"
              />
            ) : (
              <span className="text-gray-500 text-lg font-bold">
                {commnetsdata?.firstName?.[0]}
              </span>
            )}
          </div>
          <div>
            <div className="font-semibold text-gray-800">
              {commnetsdata?.firstName} {commnetsdata?.lastName}
            </div>
            <div className="text-xs text-gray-400">{commnetsdata.title}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400">
            {moment(commnetsdata?.time).format("MM/DD/YYYY")}
          </span>
          {commnetsdata.userId === userId && (
            <div className="relative">
              <button
                className="p-1 rounded-full hover:bg-gray-100"
                onClick={() => setDropList(!dropList)}
              >
                <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <circle cx="4" cy="10" r="2" />
                  <circle cx="10" cy="10" r="2" />
                  <circle cx="16" cy="10" r="2" />
                </svg>
              </button>
              {dropList && (
                <div
                  className="!absolute right-0 mt-2 w-28 bg-white border border-gray-200 rounded-lg shadow-lg z-10"
                  ref={wrapperRef}
                >
                  <ul>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
                      onClick={() =>
                        userQueryActionHandler(
                          true,
                          commnetsdata,
                          "levelTwo",
                          previousPostIndex
                        )
                      }
                    >
                      Edit
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-red-500"
                      onClick={() =>
                        postDeleteHandler(
                          commnetsdata.id,
                          "innermostRepondCollection"
                        )
                      }
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="mt-3">
        <p className="text-gray-700">{commnetsdata.description}</p>
      </div>
    </div>
  );
};